import type { StoneFragment } from '@/graphql/api'
import type { ComputedRef, Ref } from 'vue'
import { computed, toValue } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { ROUTE_DTL_REPORT } from '@/router'

export type StoneOriginReport = {
    url: string
    label: string
}

export function useStoneOriginReport(
    stone:
        | Ref<StoneFragment | undefined | null>
        | (() => StoneFragment | undefined | null)
): ComputedRef<StoneOriginReport | null> {
    const { t } = useI18n()
    const router = useRouter()

    return computed(() => {
        const s = toValue(stone)

        if (s?.dtlReport) {
            return {
                url: router.resolve({
                    name: ROUTE_DTL_REPORT,
                    params: {
                        identifier: s.identifier,
                    },
                }).fullPath,
                label: s.dtlReport.code,
            }
        }

        if (s?.scsReport) {
            return {
                url: s.scsReport,
                label: t('diamond_search.view_report'),
            }
        }

        return null
    })
}
